export default [
  {
    id: 'salt',
    name: 'Salt',
    description: 'Useful to preserve food',
    action: 'scavenge',
    usesUntilBreakdown: 0
  },
  {
    id: 'string',
    name: 'String',
    description: 'Useful for crafting',
    action: 'scavenge',
    usesUntilBreakdown: 0
  },
  {
    id: 'rope',
    name: 'Rope',
    description: 'Useful for crafting',
    action: 'craft',
    usesUntilBreakdown: 0
  },
  {
    id: 'wood',
    name: 'Wood',
    description: 'Useful for crafting',
    action: 'scavenge',
    usesUntilBreakdown: 0
  },
  {
    id: 'plastic',
    name: 'Plastic',
    description: 'Useful for crafting',
    action: 'scavenge',
    usesUntilBreakdown: 0
  },
  {
    id: 'bottle',
    name: 'Empty bottle',
    description: 'Useful for crafting',
    action: 'scavenge',
    usesUntilBreakdown: 0
  },
  {
    id: 'flint',
    name: 'Flint',
    description: 'Useful for crafting',
    action: 'scavenge',
    usesUntilBreakdown: 0
  },
  {
    id: 'medicinal-herbs',
    name: 'Medicinal herbs',
    description: 'Healing properties when brewed',
    action: 'scavenge',
    usesUntilBreakdown: 0
  },
  {
    id: 'bow',
    name: 'Bow',
    description: 'Lets you hunt and defend yourself',
    action: 'craft',
    usesUntilBreakdown: 5
  },
  {
    id: 'knife',
    name: 'Knife',
    description: 'Useful tool',
    action: 'craft',
    usesUntilBreakdown: 0
  },
  {
    id: 'rabbit',
    name: 'Dead rabbit',
    description: 'Poor little thing',
    action: 'hunt'
  },
  {
    id: 'rabbit-pelt',
    name: 'Rabbit pelt',
    description: 'It\'s not gonna be of much use until you can craft more stuff…',
    action: 'craft'
  }
]



// WEBPACK FOOTER //
// ./src/data/objects.js